import React from "react";

import { Tooltip } from "minimum-ui/core";
import styled from "styled-components";
import { Badge } from "ui/core";

export interface TagsProps {
  items: { [key: string]: string }[];
  max?: number;
}

const Tags: React.FC<TagsProps> = ({ items, max = 3 }) => {
  const normalized = items.reduce(
    (arr, item) => [...arr, ...Object.entries(item)],
    [] as [string, string][]
  );
  const tags = normalized.slice(0, max),
    excess = normalized.slice(max);
  return (
    <TagsWrapper>
      {tags.map(([category, tag], index) => (
        <Tooltip title={category} placement="bottom" key={index}>
          <Badge color="midBlue" size="medium" interactable={true}>
            {tag}
          </Badge>
        </Tooltip>
      ))}
      {!!excess.length && (
        <Tooltip
          title={excess
            .map(([category, tag]) => `${tag} (${category})`)
            .join(", ")}
          placement="bottom"
        >
          <Badge color="midBlue" size="medium" interactable={true}>
            +{excess.length}
          </Badge>
        </Tooltip>
      )}
    </TagsWrapper>
  );
};

const TagsWrapper = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 4px;
`;

export default Tags;
